(function () {
  'use strict';

  angular
    .module('cadastros.motorista.documentos', ['ui.router', 'FeatureFlagModule']);
}());
